<template>
	<div class="content-wrapper">
		<div class="container flex-grow-1 container-p-y">
			<div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-6 row-gap-4">
				<div class="d-flex flex-column justify-content-center">
					<h4 class="mb-1">{{ $t('trainings.expiring.title') }}</h4>
					<p class="mb-0">{{ $t('trainings.expiring.description') }}</p>
				</div>
			</div>

			<div class="col-lg-12">
				<div class="card h-100">
					<div class="table-responsive">
						<table class="table table-borderless">
							<thead>
								<tr class="border-bottom">
									<th class="bg-transparent fs-xsmall">{{ $t('trainings.list.training') }}</th>
									<th class="bg-transparent fs-xsmall">{{ $t('trainings.list.trainee') }}</th>
									<th class="bg-transparent fs-xsmall">{{ $t('trainings.expiring.expiresAt') }}</th>
									<th class="bg-transparent fs-xsmall">{{ $t('trainings.expiring.daysUntilExpiry') }}</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(trainee, index) in trainees" :key="index">
									<td>
										<div class="d-flex justify-content-start align-items-center">
											<div class="avatar avatar me-4">
												<span class="avatar-initial rounded-circle bg-label-warning">
													<i class="ri-alert-line"></i>
												</span>
											</div>
											<div>
												<h6 class="mb-0 text-truncate">
													Formation {{ trainee.formationTitle }}
													<span v-if="trainee.language === 'en'">(🇺🇸)</span>
												</h6>
												<p class="text-truncate mb-0" style="font-size: 12px;">
													{{ $t('trainings.expiring.finishedOn') }} {{ formatDate(trainee.finishedAt) }}
												</p>
											</div>
										</div>
									</td>
									<td>
										{{ trainee.user.firstName }} {{ trainee.user.lastName }}
										<p class="text-truncate mb-0" style="font-size: 12px;" v-if="trainee.user.agency">
											({{ trainee.user.agency }})
										</p>
									</td>
									<td>{{ formatDate(trainee.expiresAt) }}</td>
									<td>
										<span :class="badgeClass(trainee.daysUntilExpiry)">
											{{ $t('trainings.expiring.inNDays', { count: trainee.daysUntilExpiry }) }}
										</span>
									</td>
								</tr>
								<tr v-if="!trainees.length">
									<td colspan="4" class="text-center text-muted py-4">
										{{ $t('trainings.expiring.empty') }}
									</td>
								</tr>
							</tbody>
						</table>

						<div class="row mt-5" v-if="pagination.totalEntries > pagination.limit">
							<div class="col-sm-12 col-md-6">
								<div class="dataTables_info" style="padding-left: 15px; margin: 10px;">
									{{ $t('trainings.list.totalTrainings', { count: pagination.totalEntries }) }}
								</div>
							</div>
							<div class="col-sm-12 col-md-6 d-flex justify-content-end" style="padding-right: 40px;">
								<div class="pagination-container">
									<ul class="pagination">
										<li :class="['page-item', { disabled: pagination.page === 1 }]" @click="changePage(pagination.page - 1)">
											<a class="page-link"><i class="ri-arrow-left-s-line"></i></a>
										</li>
										<li v-for="page in visiblePages" :key="page" :class="['page-item', { active: page === pagination.page }]" @click="changePage(page)">
											<a class="page-link">{{ page }}</a>
										</li>
										<li :class="['page-item', { disabled: pagination.page >= pagination.totalPages }]" @click="changePage(pagination.page + 1)">
											<a class="page-link"><i class="ri-arrow-right-s-line"></i></a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import HTTP from "@/axios";

export default {
	name: "TrainingsExpiringPage",
	data() {
		return {
			trainees: [],
			pagination: {
				page: 1,
				limit: 10,
				totalEntries: 0,
				totalPages: 0,
			}
		};
	},
	computed: {
		visiblePages() {
			const total = this.pagination.totalPages;
			const current = this.pagination.page;
			const pages = [];
			const start = Math.max(1, current - 1);
			const end = Math.min(total, start + 2);
			for (let i = start; i <= end; i++) pages.push(i);
			return pages;
		}
	},
	mounted() {
		this.fetchExpiring();
	},
	methods: {
		async fetchExpiring() {
			try {
				const response = await HTTP.get(`/dashboard/expiring-trainings`, {
					params: { page: this.pagination.page, limit: this.pagination.limit }
				});
				this.trainees = response.data.trainees;
				this.pagination = { ...this.pagination, ...response.data.pagination };
			} catch (error) {
				console.error("[fetchExpiring] error:", error);
			}
		},
		changePage(page) {
			if (page < 1 || page > this.pagination.totalPages) return;
			this.pagination.page = page;
			this.fetchExpiring();
		},
		formatDate(date) {
			if (!date) return "";
			return new Date(date).toLocaleDateString(this.$i18n.locale);
		},
		badgeClass(days) {
			if (days < 30) return "badge bg-label-danger";
			if (days < 60) return "badge bg-label-warning";
			return "badge bg-label-info";
		},
	}
};
</script>
